<template lang="pug">

main.modal-wrapper
    svg-icon.close-modal.cursor(name='close' size="small" @click.native="closeModal()")

    div.modal-main

        header.modal-header
            sectionHeader(:title="isEditing? 'Edit alert' : 'Create alert'")

        div.modal-body
            //- Object Type
            div.form-subsection(:disabled="editableAlert" :class="{'opacity-disabled': editableAlert}")
                div.form-label
                    label Object type
                el-select.capitalize-label(:disabled="editableAlert" v-model="objectType")
                    el-option(
                        v-for="type in objectTypeOptions"
                        :key="type.value"
                        :value="type.value"
                    ) {{ type.label }}

            div.form-subsection(:disabled="editableAlert" v-if="objectType !== 'account'" :class="{'opacity-disabled': editableAlert}")
                div.form-label__required
                    label Selected Object

                spinner(v-if="allocationTop.loading && !isEditing" width="20" height="20")

                el-select(
                    v-else
                    filterable
                    :filter-method="filterSearch"
                    v-model="selectedObjectId"
                    placeholder="Select an object"
                    :disabled="editableAlert"
                )
                    el-option(
                        v-for="item in filteredMatches"
                        :key="item.id"
                        :label="item.label + ' - ' + item.id "
                        :value="item.id"
                    )
                        div.full-width.l-flex-row--between(style="max-width:400px")
                            p.is-truncate(:title="item.label") {{ item.label }}
                            span(style="color: #8492a6; font-size: 13px") {{ item.id }}

            //- LABEL
            div.form-subsection(:disabled="!userCanEditAlert")
                div.form-subsection
                    div.form-label__required
                        label Alert Name
                    input.form-input(
                        v-model="label"
                        placeholder="label"
                        id="label"
                        name="label"
                        v-validate="'max:200|required|allowed_characters'"
                        type="text")
                    span.form-validate-error(v-if="nonAsciiLabel") Only ASCII characters are allowed
                    span.form-validate-error(v-else) {{ errors.first('label') }}

            //- Alert id
            .form-subsection(v-if="isEditing" disabled)
                div.form-subsection
                    div.form-label__required
                        label Alert id
                    input.form-input(
                        :value="alertInEdition.id"
                        placeholder="alert id"
                        id="alert id"
                        name="alert id"
                        type="text")

            //- Status
            div.form-section(v-if="isEditing" :disabled="!userCanEditAlert")
                div.form-section--switch.l-flex-row--between
                    div.form-label.l-flex-row.flex-1
                        label.flex-1(for="switch-alert-status") Status
                    div.onoffswitch
                        input(
                            id="switch-alert-status"
                            name="switch-status"
                            class="onoffswitch-checkbox"
                            type="checkbox"
                            v-model="status"
                            true-value="active"
                            false-value="inactive"
                        )
                        label(class="onoffswitch-label" for="switch-alert-status")

            //- EMAIL
            div.form-subsection(:disabled="!userCanEditAlert")
                div.form-label__required
                    label Email
                input.form-input(
                    id="email"
                    name="email"
                    placeholder="user@weborama.com"
                    v-model="email"
                    v-validate="'max:255|required|email'"
                    @blur="handleResetFieldOnLeave('email')"
                    type="text"
                )
                span.form-validate-error {{ errors.first('email') }}

            //- cc
            div.form-subsection(:disabled="!userCanEditAlert")
                div.form-label.l-flex-row--between
                    label Emails Cc
                    div.counter {{ ccList.length }} /10
                EmailCcField(
                    parent="FormCreateAudience"
                    placeholder="cc@weborama.com"
                    :maxItems="10"
                    :defaultValues="ccList"
                    @formCcListUpdate="updateFormCcList"
                    )

            div.l-flex-row.has-gutter_medium(:disabled="!userCanEditAlert")
                div.form-subsection.w-180.simple
                    div.form-label
                        label Alert type
                    div.l-flex-row--between.l-align-center
                        div.form-radio-item.form-radio-item--left
                            input(type="radio" id="threshold" value="threshold" v-model="alertType")
                            label(for="threshold") Threshold
                        div.form-radio-item.form-radio-item--right
                            input(type="radio" id="trend" value="trend" v-model="alertType")
                            label(for="trend") Trend

            //- Specific elements
            div.form-section

                //- Threshold specific fields
                div.form-alert-threshold(v-if="alertType === 'threshold'")
                    div.form-subsection(:disabled="!userCanEditAlert")
                        div.form-label
                            label Observation period
                        select.form-select.big.square.w-180.select-exportdata-type(v-model="observationPeriodThreshold")
                            option(
                                v-for="type in observationPeriodOptionsThreshold"
                                :key="type.label"
                                :value="type") {{ type.label }}
                    div.form-subsection(:disabled="!userCanEditAlert")
                        div.l-flex-row--between.threshold-range
                            div.form-label
                                label Below
                                p.form-section-subtitle--bootstrap max value: {{ maxLimit }}
                            div
                                el-input-number(
                                    size="mini"
                                    class="alert-input-number"
                                    name="thresholdBelow"
                                    @change="changeBelow"
                                    @blur="resetThreshold('below', $event.target.value)"
                                    v-validate="vvalidateBelowLimit"
                                    :step-strictly="true"
                                    :value="thresholdRange.below"
                                    :min="0"
                                    :max="maxLimit"
                                )
                        span.form-validate-error(v-if="errors.first('thresholdBelow')") {{ errors.first('thresholdBelow') }}


                    div.form-subsection(:disabled="!userCanEditAlert")
                        div.l-flex-row--between.threshold-range
                            div.form-label
                                label Above
                                p.form-section-subtitle--bootstrap max value: {{ maxLimit }}
                            div
                                el-input-number(
                                    size="mini"
                                    class="alert-input-number"
                                    name="thresholdAbove"
                                    @change="changeAbove"
                                    @blur="resetThreshold('above', $event.target.value)"
                                    v-validate="vvalidateAboveLimit"
                                    :value="thresholdRange.above"
                                    :min="0"
                                    :max="maxLimit"
                                )
                        span.form-validate-error(v-if="errors.first('thresholdAbove')") {{ errors.first('thresholdAbove') }}


                //- Trend specific fields
                div.form-alert-trend(v-if="alertType === 'trend'")
                    div.form-subsection(:disabled="!userCanEditAlert")
                        div.form-label
                            label Observation period
                        select.form-select.big.square.w-180.select-exportdata-type(v-model="observationPeriodTrend")
                            option(
                                v-for="type in observationPeriodOptionsTrend"
                                :key="type.label"
                                :value="type") {{ type.label }}

                    div.form-subsection(:disabled="!userCanEditAlert")
                        div.form-label
                            label Reference day
                        select.form-select.big.square.w-180.select-exportdata-type(v-model="referenceDay")
                            option(
                                v-for="type in referenceDayOptions"
                                :key="type.label"
                                :value="type") {{ type.label }}

                    div.form-subsection(:disabled="!userCanEditAlert" v-if="observationPeriodTrend.value !== 'day'")
                        div.form-label
                            label Time period

                        el-time-select(
                            v-if="observationPeriodTrend.value === 'single'"
                            v-model="singleHour"
                            :picker-options="singlePickerOptions"
                            placeholder="Select an hour"
                        )

                        DoubleClockRange(
                            v-else-if="observationPeriodTrend.value === 'range'"
                            v-model="trendHoursRange"
                            :minInterval="3"
                            :maxInterval="12"
                        )

                    div.form-subsection(:disabled="!userCanEditAlert")
                        div.l-flex-row--between.threshold-range
                            div.form-label
                                label Increase Change
                            div
                                el-input-number(
                                    size="mini"
                                    :max="100"
                                    :min="0"
                                    name="increaseChange"
                                    @change="changeIncrease"
                                    v-validate="'decimal|max_value:100|min_value:0'"
                                    :value="increase"
                                )
                                span.form-validate-error(v-if="errors.first('increaseChange')") {{ errors.first('increaseChange') }}


                    div.form-subsection(:disabled="!userCanEditAlert")
                        div.l-flex-row--between.threshold-range
                            div.form-label
                                label Decrease change
                            div
                                el-input-number(
                                    size="mini"
                                    :max="100"
                                    :min="0"
                                    name="thresholdAbove"
                                    @change="changeDecrease"
                                    v-validate="'decimal|max_value:100|min_value:0'"
                                    :value="decrease"
                                )
                                span.form-validate-error(v-if="errors.first('thresholdAbove')") {{ errors.first('thresholdAbove') }}



        //- FOOTER
        footer.modal-footer
            div.footer-content.l-flex-row--between
                button.btn.btn--medium.btn--round(@click="closeModal()") Cancel
                button.btn.btn--medium.btn--round.btn-rev.btn-save-audience(
                    @click="handleSubmit()"
                    type="button"
                    :class="{'ui-disabled': disabledButton}") {{ isEditing ? 'Edit' : 'Save' }}
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import Vue from 'vue'
import { cloneDeep, flatten, isEqual, isEmpty, isNil, keyBy, toNumber } from 'lodash'
import { Validator } from 'vee-validate'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { filterByQuery } from '@/utils/filters'
dayjs.extend(customParseFormat)
import { getTokenUserEmail } from '@/utils/helpers'
import SectionHeader from '@/components/common/SectionHeader'
import EmailCcField from '@/components/common/EmailCcField'
import DoubleClockRange from '@/components/dashboard/DoubleClockRange'

export default {
    name: 'AlertForm',

    components: {
        SectionHeader,
        EmailCcField,
        DoubleClockRange
    },

    data() {
        return {
            isProcessing: false,
            label: '',
            email: getTokenUserEmail(Vue.prototype.$keycloak),
            formHistoryEmail: getTokenUserEmail(Vue.prototype.$keycloak),
            ccList: [],
            alertType: 'threshold',
            maxLimit: 999999999999999,

            //Object Selection
            objectType: 'account',
            objectTypeOptions: [
                {
                    label: 'Account',
                    value: 'account'
                },
                {
                    label: 'Audience',
                    value: 'audience'
                },
                {
                    label: 'Segments',
                    value: 'segments'
                }
            ],
            selectedObjectId: null,

            // threshold
            observationPeriodOptionsThreshold: [
                {
                    label: 'Last 30 days',
                    value: 'days'
                },
                {
                    label: 'Last 24 hours',
                    value: 'hours'
                }
            ],
            observationPeriodThreshold: {
                label: 'Last 30 days',
                value: 'days'
            },
            thresholdRange: {
                below: 0,
                above: 0
            },

            //trend
            observationPeriodOptionsTrend: [
                {
                    label: 'Day',
                    value: 'day'
                },
                {
                    label: 'Single hour',
                    value: 'single'
                },
                {
                    label: 'Range of hour',
                    value: 'range'
                }
            ],
            observationPeriodTrend: {
                label: 'Day',
                value: 'day'
            },
            referenceDayOptions: [
                {
                    label: '1 day ago',
                    value: 'oneDay'
                },
                {
                    label: '7 days ago',
                    value: 'sevenDays'
                }
            ],
            referenceDay: {
                label: '1 day ago',
                value: 'oneDay'
            },
            singleHour: '00:00',
            singlePickerOptions: {
                start: '00:00',
                step: '01:00',
                end: '23:00'
            },
            trendHoursRange: ['00:00', '03:00'],
            increase: 0,
            decrease: 0,
            isEditing: false,
            isCreatingFromObject: false,
            status: null,
            filteredMatches: [],
            originalAlert: {}
        }
    },

    computed: {
        // Call to state
        ...mapState('dashboard', {
            allocationTop: state => state.allocationTop,
            alertInEdition: state => cloneDeep(state.alertInEdition),
            alertInCreation: state => state.alertInCreation
        }),

        ...mapState('account', {
            accountId: state => state.accountId
        }),

        ...mapState('data/audience', {
            audiences: state => keyBy(state.list, 'id')
        }),

        ...mapState('data/customTaxonomies', {
            segments: state => keyBy(flatten(Object.values(state.hierarchies)), 'id')
        }),

        ...mapGetters('account', ['getEditAlertsAllowed', 'getReadAlertsAllowed']),

        selectionnableObjects() {
            const sources = {
                audience: 'audiences',
                segments: 'segments'
            }
            const source = sources[this.objectType]

            if (this.isEditing) {
                if (this.objectType === 'account') return []
                return Object.values(this[source])
            }
            return source
                ? Object.values(this.allocationTop[source])
                    .map(item => this[source][item.id])
                    .filter(item => item)
                : []
        },

        disabledButton() {
            const typeDisable = this.alertType === 'threshold' ? this.thresholdDisable : this.trendDisable
            return this.commonDisable || typeDisable
        },

        commonDisable() {
            if (!this.userCanEditAlert) return true
            const isObjectIdEmpty = this.objectType === 'account' ? false : this.selectedObjectId == null
            return !this.hasChange || this.errors.all().length > 0 || isEmpty(this.label) || isObjectIdEmpty || this.isProcessing
        },

        thresholdDisable() {
            return !this.thresholdRange.below && !this.thresholdRange.above
        },

        trendDisable() {
            const isEmptyChanges = !this.increase && !this.decrease
            return isEmptyChanges
        },

        nonAsciiLabel() {
            return !isEmpty(this.label) && this.errors.firstByRule('label', 'ascii')
        },

        vvalidateBelowLimit() {
            const aboveLimit = this.thresholdRange.above - 1
            return this.thresholdRange.above ? `${'decimal|min_value:0|max_value:' + aboveLimit}` : `${'decimal|min_value:0|max_value:' + this.maxLimit}`
        },

        vvalidateAboveLimit() {
            if (!this.thresholdRange.above) return `${'decimal|max_value:' + this.maxLimit}`
            const below_limit = this.thresholdRange.below + 1
            return this.thresholdRange.below
                ? `${'decimal|max_value:' + this.maxLimit + '|min_value:' + below_limit}`
                : `${'decimal|min_value:0|max_value:' + this.maxLimit}`
        },

        triggerConditionThreshold() {
            const res = {
                type: 'threshold_v1',
                configuration: {
                    period: this.observationPeriodThreshold.value === 'days' ? 'last30days' : 'last24hours'
                }
            }
            // add conditionally increase and decrease depending on if the input have been filled or not
            if (this.thresholdRange.above) res.configuration.high = Math.trunc(this.thresholdRange.above)
            if (this.thresholdRange.below) res.configuration.low = Math.trunc(this.thresholdRange.below)

            return res
        },

        triggerConditionTrend() {
            const res = {
                type: 'trend_v1',
                configuration: {
                    period: 'day',
                    compared_to: this.referenceDay.value === 'oneDay' ? 'a_day_ago' : 'a_week_ago'
                }
            }

            // add conditionally increase and decrease depending on if the inputs have been filled or not
            if (this.increase) res.configuration.percentage_increase = this.increase
            if (this.decrease) res.configuration.percentage_decrease = this.decrease

            if (this.observationPeriodTrend.value === 'single') {
                const hour = toNumber(dayjs(this.singleHour, 'HH:mm').format('HH'))
                res.configuration.hour = hour
            } else if (this.observationPeriodTrend.value === 'range') {
                const hour = toNumber(dayjs(this.trendHoursRange[0], 'HH:mm').format('HH'))
                const end = toNumber(dayjs(this.trendHoursRange[1], 'HH:mm').format('HH'))
                res.configuration.hour = hour
                res.configuration.hour_end = end
            }

            return res
        },

        triggerCondition() {
            return this.alertType === 'threshold' ? this.triggerConditionThreshold : this.triggerConditionTrend
        },

        notification() {
            return {
                type: 'email_v1',
                configuration: {
                    to: [this.email],
                    cc: this.ccList
                }
            }
        },

        hasChange() {
            if (!this.isEditing) return true

            return !isEqual(this.originalAlert, {
                id: this.alertInEdition.id,
                label: this.label,
                triggerType: this.alertType,
                triggerCondition: this.triggerCondition,
                notification: this.notification,
                status: this.status,
                cc: this.ccList
            })
        },

        userCanEditAlert() {
            return this.getReadAlertsAllowed() && this.getEditAlertsAllowed()
        },

        editableAlert() {
            return this.isEditing || !this.userCanEditAlert
        }
    },

    watch: {
        singleHour(val, oldVal) {
            if (!val) this.singleHour = oldVal
        },

        objectType() {
            if (!this.isEditing) this.selectedObjectId = null
        },

        selectionnableObjects(val) {
            this.filteredMatches = val
        }
    },

    created() {
        const dict = {
            custom: {
                thresholdBelow: {
                    max_value: 'The value is incorrect. The “Below” value should be inferior to the “Above” value.'
                },
                thresholdAbove: {
                    min_value: 'The value is incorrect. The “Below” value should be inferior to the “Above” value.'
                }
            }
        }
        this.$validator.localize('en', dict)
    },

    mounted() {
        Validator.extend('allowed_characters', {
            getMessage: () => 'Please use only letters, numbers, spaces, dashes or underscores',
            validate: value => RegExp('^[-_ a-zA-Z0-9]*$').test(value)
        })
        const instance = new Validator({ label: 'allowed_characters' })
        instance.attach('label', 'allowed_characters')

        // Set the values of an in edition alert
        if (!isEmpty(this.alertInEdition)) {
            this.resetValidation()
            this.fillFormWithEditionData()
        } else if (!isEmpty(this.alertInCreation)) {
            this.resetValidation()
            this.fillFormWithCreationFromObjectData()
        }
    },

    destroyed() {
        this.setAlertInEdition({ alert: {} })
        this.setAlertInCreation(null)
    },

    methods: {
        ...mapMutations('dashboard', ['setDisplayAlertForm', 'setAlertInEdition', 'setAlertInCreation']),

        ...mapActions('dashboard', ['createAlert', 'editAlert']),

        closeModal() {
            this.setDisplayAlertForm({ value: false })
        },

        handleResetFieldOnLeave(field) {
            if (field === 'email' && this.errors.has('email')) this.email = this.formHistoryEmail
        },

        updateFormCcList(ccList) {
            this.ccList = ccList
        },

        changeBelow(value) {
            this.thresholdRange.below = Math.round(value)
        },

        changeAbove(value) {
            this.thresholdRange.above = Math.round(value)
        },

        resetThreshold(input, value) {
            if (value === '') input === 'below' ? (this.thresholdRange.below = 0) : (this.thresholdRange.above = 0)
        },

        changeIncrease(value) {
            this.increase = value
        },

        changeDecrease(value) {
            this.decrease = value
        },

        handleSubmit() {
            this.isProcessing = true

            if (!this.isEditing) {
                this.createAlert({
                    label: this.label,
                    objectType: this.objectType === 'segments' ? 'cs' : this.objectType,
                    objectId: this.objectType === 'account' ? this.accountId : this.selectedObjectId,
                    triggerType: this.alertType,
                    triggerCondition: this.triggerCondition,
                    notification: this.notification
                }).then(() => {
                    this.isProcessing = false
                })
            } else {
                this.editAlert({
                    id: this.alertInEdition.id,
                    label: this.label,
                    triggerType: this.alertType,
                    triggerCondition: this.triggerCondition,
                    notification: this.notification,
                    status: this.status
                }).then(() => {
                    this.isProcessing = false
                })
            }
        },

        fillFormWithEditionData() {
            this.isEditing = true
            this.label = this.alertInEdition.label
            this.objectType = this.objectTypeOptions.find(type => type.value === this.alertInEdition.objectType).value
            this.ccList = [...this.alertInEdition.notification.configuration.cc]
            this.email = this.alertInEdition.notification.configuration.to[0]
            this.alertType = this.alertInEdition.triggerType
            this.status = this.alertInEdition.status

            if (this.objectType !== 'account') {
                this.selectedObjectId = this.alertInEdition.objectId
            }

            if (this.alertInEdition.triggerType === 'threshold') {
                this.observationPeriodThreshold =
                    this.alertInEdition.triggerCondition.configuration.period === 'last30days'
                        ? this.observationPeriodOptionsThreshold[0]
                        : this.observationPeriodOptionsThreshold[1]

                this.thresholdRange = {
                    below: this.alertInEdition.triggerCondition.configuration.low || 0,
                    above: this.alertInEdition.triggerCondition.configuration.high || 0
                }
            } else {
                // Observation period and time period
                if (isNil(this.alertInEdition.triggerCondition.configuration.hour)) this.observationPeriodTrend = this.observationPeriodOptionsTrend[0]
                else if (
                    !isNil(this.alertInEdition.triggerCondition.configuration.hour) &&
                    isNil(this.alertInEdition.triggerCondition.configuration.hour_end)
                ) {
                    this.observationPeriodTrend = this.observationPeriodOptionsTrend[1]
                    this.singleHour = `${this.alertInEdition.triggerCondition.configuration.hour}:00`
                } else {
                    this.observationPeriodTrend = this.observationPeriodOptionsTrend[2]
                    this.trendHoursRange[0] = `${this.alertInEdition.triggerCondition.configuration.hour}:00`
                    this.trendHoursRange[1] = `${this.alertInEdition.triggerCondition.configuration.hour_end}:00`
                }

                this.increase = this.alertInEdition.triggerCondition.configuration.percentage_increase || 0
                this.decrease = this.alertInEdition.triggerCondition.configuration.percentage_decrease || 0

                this.referenceDay =
                    this.alertInEdition.triggerCondition.configuration.compared_to === 'a_day_ago' ? this.referenceDayOptions[0] : this.referenceDayOptions[1]
            }

            this.originalAlert = {
                id: this.alertInEdition.id,
                label: this.label,
                triggerType: this.alertType,
                triggerCondition: this.triggerCondition,
                notification: this.notification,
                status: this.status,
                cc: this.alertInEdition.notification.configuration.cc
            }
        },

        fillFormWithCreationFromObjectData() {
            this.isCreatingFromObject = true
            this.objectType = this.alertInCreation.objectType
            this.$nextTick(() => {
                this.selectedObjectId = this.alertInCreation.objectId
            })
        },

        resetValidation() {
            this.$validator.pause()
            this.$nextTick(() => {
                this.$validator.errors.clear()
                this.$validator.fields.items.forEach(field => field.reset())
                this.$validator.fields.items.forEach(field => this.errors.remove(field))
                this.$validator.resume()
            })
        },

        filterSearch(input) {
            if (input === '') {
                this.filteredMatches = this.selectionnableObjects
                return
            }
            const result = filterByQuery(this.selectionnableObjects, input, ['label', 'id'])
            this.filteredMatches = result.map(item => item.item)
        }
    }
}
</script>

<style lang="scss">
.el-input-number--mini {
    &.alert-input-number {
        width: 230px;
    }
}
</style>
